/**
 * Custom dropdown for Gravity Forms selects inside .download-form.
 * The native <select> stays in the DOM (hidden) so submission, validation
 * and conditional logic keep working; this script only drives its value.
 * Floating label reuses the theme classes: .gfield-focus / .input-not-empty.
 */
(function () {
  var ROOT = '.download-form';
  var uid = 0;

  function enhance(select) {
    if (select.dataset.cSelect) return;
    select.dataset.cSelect = '1';

    var container = select.parentElement; // .ginput_container_select
    var field = select.closest('.gfield');
    var label = field && field.querySelector('.gfield_label');
    var placeholder = select.querySelector('option.gf_placeholder, option[value=""]');
    var base = select.id || 'c-select-' + ++uid;

    // Label text = placeholder text ("AI tool*"), so the floating label matches the design
    if (label && placeholder) {
      var labelText = label.querySelector('.gform-field-label__text') || label;
      labelText.textContent = placeholder.textContent.trim();
    }
    if (label && !label.id) label.id = base + '-label';

    container.classList.add('c-select');
    select.classList.add('c-select__native');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'c-select__trigger';
    trigger.id = base + '-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', base + '-listbox');

    var value = document.createElement('span');
    value.className = 'c-select__value';
    value.id = base + '-value';
    trigger.appendChild(value);
    trigger.setAttribute('aria-labelledby', (label ? label.id + ' ' : '') + value.id);

    var list = document.createElement('ul');
    list.className = 'c-select__list';
    list.id = base + '-listbox';
    list.setAttribute('role', 'listbox');
    list.setAttribute('tabindex', '-1');
    if (label) list.setAttribute('aria-labelledby', label.id);

    var items = [];
    Array.prototype.forEach.call(select.options, function (opt, i) {
      if (opt === placeholder || opt.disabled) return;
      var li = document.createElement('li');
      li.className = 'c-select__option';
      li.id = base + '-opt-' + i;
      li.setAttribute('role', 'option');
      li.textContent = opt.textContent;
      li.dataset.index = i;
      list.appendChild(li);
      items.push(li);
    });

    container.appendChild(trigger);
    container.appendChild(list);

    var active = -1;

    function sync() {
      var has = select.value !== '';
      value.textContent = has ? select.options[select.selectedIndex].textContent : '';
      items.forEach(function (li) {
        li.setAttribute('aria-selected', String(+li.dataset.index === select.selectedIndex));
      });
      if (field) field.classList.toggle('input-not-empty', has);
    }

    function setActive(i) {
      items.forEach(function (li) { li.classList.remove('is-active'); });
      active = i;
      if (i < 0) { trigger.removeAttribute('aria-activedescendant'); return; }
      items[i].classList.add('is-active');
      trigger.setAttribute('aria-activedescendant', items[i].id);
      var li = items[i];
      if (li.offsetTop < list.scrollTop) list.scrollTop = li.offsetTop;
      else if (li.offsetTop + li.offsetHeight > list.scrollTop + list.clientHeight) {
        list.scrollTop = li.offsetTop + li.offsetHeight - list.clientHeight;
      }
    }

    function isOpen() { return container.classList.contains('is-open'); }

    function open() {
      if (isOpen()) return;
      document.querySelectorAll(ROOT + ' .c-select.is-open').forEach(function (el) {
        el.dispatchEvent(new CustomEvent('c-select:close'));
      });
      container.classList.add('is-open');
      if (field) field.classList.add('gfield-focus');
      trigger.setAttribute('aria-expanded', 'true');
      var sel = items.findIndex(function (li) { return +li.dataset.index === select.selectedIndex; });
      setActive(sel); // nothing highlighted until a value is chosen or arrows are used
    }

    function close() {
      if (!isOpen()) return;
      container.classList.remove('is-open');
      if (field) field.classList.remove('gfield-focus');
      trigger.setAttribute('aria-expanded', 'false');
      setActive(-1);
    }

    function choose(i) {
      var idx = +items[i].dataset.index;
      if (select.selectedIndex !== idx) {
        select.selectedIndex = idx;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
      close();
      trigger.focus();
    }

    container.addEventListener('c-select:close', close);

    trigger.addEventListener('click', function () { isOpen() ? close() : open(); });

    trigger.addEventListener('keydown', function (e) {
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (!isOpen()) open(); else setActive(Math.min(active + 1, items.length - 1));
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (!isOpen()) open(); else setActive(Math.max(active - 1, 0));
          break;
        case 'Home':
          if (isOpen()) { e.preventDefault(); setActive(0); }
          break;
        case 'End':
          if (isOpen()) { e.preventDefault(); setActive(items.length - 1); }
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (isOpen() && active >= 0) choose(active); else open();
          break;
        case 'Escape':
          if (isOpen()) { e.preventDefault(); close(); }
          break;
        case 'Tab':
          close();
          break;
      }
    });

    list.addEventListener('mousedown', function (e) { e.preventDefault(); }); // keep focus on trigger
    list.addEventListener('click', function (e) {
      var li = e.target.closest('.c-select__option');
      if (li) choose(items.indexOf(li));
    });
    list.addEventListener('mousemove', function (e) {
      var li = e.target.closest('.c-select__option');
      if (li) setActive(items.indexOf(li));
    });

    // Label click opens the dropdown instead of focusing the hidden select
    if (label) {
      label.addEventListener('click', function (e) {
        e.preventDefault();
        trigger.focus();
        open();
      });
    }

    document.addEventListener('click', function (e) {
      if (!container.contains(e.target) && !(label && label.contains(e.target))) close();
    });

    // External value changes (GF conditional logic, form reset)
    select.addEventListener('change', sync);

    sync();
  }

  function init() {
    document.querySelectorAll(ROOT + ' select.gfield_select').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Gravity Forms re-renders the form after AJAX submit / validation errors
  if (window.jQuery) {
    window.jQuery(document).on('gform_post_render', init);
  }
})();
